import { AdImage } from './AdImage';
import { AdVideo } from './AdVideo';

/** One asset in a business's media library, tagged because an image and a video can share an id. */
export type AdMediaItem =
  | { mediaType: 'image'; asset: AdImage }
  | { mediaType: 'video'; asset: AdVideo };

export type AdMediaType = AdMediaItem['mediaType'];

/** One page of a business's media library, newest first. */
export interface AdMediaPage {
  items: AdMediaItem[];
  hasMore: boolean;
}

export const AD_MEDIA_PAGE_SIZE = 40;
